import { fortnoxConnectionLogService } from '../services'
const state = {
  all: {
    filterInitialized: false,
    defaultFilter: {
      mobilePhone: null,
      orderByColumn: 'dateTime',
      orderByDescending: true
    },
    currentPage: 1,
    loading: true,
    saving: false,
    items: [],
    filter: {},
    meta: {}
  }
}

const actions = {
  getListData ({ commit }) {
    fortnoxConnectionLogService.getListData(state.all.filter, state.all.currentPage)
      .then(
        data => {
          commit('getListDataSuccess', data.result)
          return data.result
        }
      )
  },

  cleanup ({ commit }, days) {
    return fortnoxConnectionLogService.cleanup(days)
      .then(
        data => {
          return data.result
        }
      )
  }
}

const mutations = {
  getListDataSuccess (state, data) {
    state.all.items = data.items
    state.all.meta = data.meta
    state.all.loading = false
  }
}

export const fortnoxConnectionLogs = {
  namespaced: true,
  actions,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/fortnox-connection-logs.module.js